module.exports = __webpack_public_path__ + "img/comission_details.7f8ab16f.svg";